import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const UserMail = ({ userId, className = '' }) => {
   const user = useSelector(state => state.userInfoData?.users[userId]);
   const email = user?.email;
   return <span className={className}>{email}</span>;
};

UserMail.propTypes = {
   userId: PropTypes.string.isRequired,
   className: PropTypes.string,
};
